<template>
  <div class="student-plan-detail">
    <div class="page-header">
      <h1>计划详情</h1>
      <p>计划ID: {{ $route.params.id }}</p>
      <p>学习计划详情页面，开发中...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudentPlanDetail'
}
</script>

<style lang="less" scoped>
.student-plan-detail {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  text-align: center;
  
  h1 {
    margin: 0 0 16px 0;
    color: #2c3e50;
  }
  
  p {
    color: #7f8c8d;
    margin: 8px 0;
  }
}
</style>
